export function isLocalEAPDevMode() {
  return (
    !process.env.VITE_LOCAL_TUNNEL_ID &&
    (process.env.MODE === 'eap' || isRemoteEAPDevMode())
  );
}

export function shouldShowDevUI() {
  return (
    !process.env.VITE_LOCAL_TUNNEL_ID &&
    (process.env.MODE === 'eap' || isRemoteEAPDevMode())
  );
}

/**
 * Returns true for branch deployments
 */
export function isRemoteEAPDevMode() {
  return process.env.MODE === 'ddev' || process.env.MODE === 'development';
}
